module.exports = __webpack_public_path__ + "static/media/circle-bingo.e198a20f.svg";